import React from 'react';

import { SisternodeOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';

import { useGlobalModal } from 'hooks';
import { useCheckMasterAPLExist, useCheckProductAdministrator } from './hooks';

const CreateMasterAplRibbon = () => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const isMasterAplExist = useCheckMasterAPLExist();

  const isProductAdministrator = useCheckProductAdministrator();

  const isDisabled = isMasterAplExist || !isProductAdministrator;

  return (
    <RibbonButton
      size='small'
      icon={<SisternodeOutlined />}
      label={'Create Master APL'}
      onClick={() => openModal(MODAL_NAMES.CREATE_MASTER_APL)}
      disabled={isDisabled}
    />
  );
};

export default CreateMasterAplRibbon;
